import {
  getAvailabilityCutOffForStartOrEnd,
  getNextValidAvailabilitySp,
} from '@see-power-pft-common-js/availability/utils';
import { PREVIEW_ENTRY_ID } from 'pages/Availability/common/utils';
import { BaseAvailabilityEntry } from 'pages/Availability/types';

export interface ReductionActionPermissions {
  enableCancel: boolean;
  enableEdit: boolean;
  enableEndAndStartNew: boolean;
  enableEnd: boolean;
  enableInfo: boolean;
}

export const getReductionActionPermissions = (
  reduction: BaseAvailabilityEntry,
  now: Date = new Date(),
): ReductionActionPermissions => {
  if (!reduction.start) {
    return {
      enableCancel: false,
      enableEdit: false,
      enableEndAndStartNew: false,
      enableEnd: false,
      enableInfo: false,
    };
  }

  const startDate = new Date(reduction.start);
  const cutOffForExistingStart = getAvailabilityCutOffForStartOrEnd(startDate);

  const isAlreadyStarted = startDate <= now;
  const isAboutToStart = cutOffForExistingStart <= now;
  const hasStarted = isAlreadyStarted || isAboutToStart;

  const hasEnded = (() => {
    const endDate = reduction.end ? new Date(reduction.end) : null;
    if (!endDate) return false;

    const isAlreadyEnded = endDate <= getNextValidAvailabilitySp(now);
    const cutOffForExistingEnd = getAvailabilityCutOffForStartOrEnd(endDate);
    const isAboutToEnd = cutOffForExistingEnd <= now;

    return isAlreadyEnded || isAboutToEnd;
  })();

  const isCancelled = reduction.isCancelled ?? false;

  const isPreview = reduction.id === PREVIEW_ENTRY_ID;

  return {
    enableCancel: !isPreview && !hasStarted && !isCancelled,
    enableEdit: !isPreview && !hasEnded && !isCancelled,
    enableEndAndStartNew: !isPreview && hasStarted && !hasEnded && !isCancelled,
    enableEnd: !isPreview && hasStarted && !hasEnded && !isCancelled,
    enableInfo: !isPreview,
  };
};
